import { ReactComponent as ArrowUp } from './svg/arrowUp.svg'

export default ArrowUp
